import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthUser } from "../hooks/useAuthUser";

interface SandboxGuardProps {
  redirectTo?: string;
}

export const SandboxGuard: React.FC<SandboxGuardProps> = ({ redirectTo = "/dashboard" }) => {
  const { isSandbox } = useAuthUser();

  if (isSandbox) return <Navigate to={redirectTo} replace />;

  return <Outlet />;
};
